import React, { SVGProps } from 'react'
const SvgExpensePopup = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={103}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#Expense-Popup_svg__a)"
      d="M61.858 4.632 37.973-1.49a2.7 2.7 0 0 0-2.177.346L3.559 20.181c-1.97 1.303-2.441 4.1-1.056 6.263L44.215 91.59c1.384 2.163 4.092 2.857 6.062 1.554l45.086-29.826c1.97-1.303 2.442-4.1 1.057-6.264L63.743 6.02a3.2 3.2 0 0 0-1.885-1.387Z"
      opacity={0.3}
    />
    <g filter="url(#Expense-Popup_svg__b)">
      <path
        fill="url(#Expense-Popup_svg__c)"
        d="M75.544 1.24 51.27-10.434c-.78-.376-1.628-.402-2.364-.081L11.177 5.909c-2.305 1.004-3.274 3.947-2.17 6.59l33.252 79.608c1.104 2.643 3.856 3.967 6.16 2.963l52.768-22.97c2.305-1.004 3.275-3.948 2.171-6.59L77.308 3.143c-.353-.844-.983-1.529-1.764-1.904Z"
      />
      <g filter="url(#Expense-Popup_svg__d)">
        <path
          fill="#fff"
          d="M28.168 28.66a.898.898 0 0 1 .512-.535l1.247-.543.238-.061c.376-.065.728.08 1.05.45.39.567 1.008.95 1.855 1.148.835.204 1.887.029 3.145-.519 1.364-.594 2.263-1.268 2.703-2.012.426-.71.464-1.45.134-2.241-.21-.504-.517-.838-.93-1.027-.445-.203-1.04-.298-1.786-.285-.779-.002-1.935.09-3.457.272l-.715.084c-1.158.122-2.143.125-2.969.045-1.013-.097-1.872-.39-2.58-.889-.714-.51-1.274-1.287-1.705-2.319-.581-1.39-.578-2.78.025-4.163.547-1.287 1.572-2.357 3.04-3.236l-.627-1.5-.067-.225a.874.874 0 0 1 .062-.551c.106-.245.294-.426.553-.539l.94-.41.21-.062a.943.943 0 0 1 .534.08c.228.112.405.305.516.568l.626 1.5.377-.094a7.28 7.28 0 0 1 2.112-.168l.506.048c1.027.163 1.9.491 2.614 1.002.714.512 1.245 1.117 1.59 1.845a.961.961 0 0 1 .02.743.946.946 0 0 1-.526.54l-1.293.563-.174.048c-.14.032-.294.029-.447-.004-.267-.04-.486-.2-.665-.462-.348-.6-.904-.967-1.707-1.127-.832-.162-1.734-.025-2.721.405-1.082.47-1.843 1.043-2.268 1.724-.415.634-.45 1.316-.125 2.095.22.528.52.88.897 1.084.406.206.971.328 1.686.343.503.007 1.141-.03 1.918-.098l1.256-.122c1.621-.21 2.937-.286 3.964-.223 1.05.053 1.939.318 2.666.795.715.482 1.3 1.248 1.73 2.28.656 1.57.64 3.094-.053 4.53-.635 1.339-1.767 2.455-3.373 3.367l.626 1.499.062.214c.03.171.019.346-.037.512a.96.96 0 0 1-.538.574l-.952.415-.198.058a.982.982 0 0 1-.519-.044c-.263-.098-.445-.302-.566-.59l-.62-1.487-.409.121a8.145 8.145 0 0 1-2.262.305l-.525-.026c-1.106-.086-2.043-.4-2.831-.922a4.895 4.895 0 0 1-1.773-2.049.906.906 0 0 1 .003-.724Z"
        />
      </g>
      <g filter="url(#Expense-Popup_svg__e)">
        <path
          fill="#fff"
          fillOpacity={0.6}
          d="m35.816 44.102 19.4-8.445a1.9 1.9 0 0 1 2.514 1.031c.416.995-.036 2.142-1.012 2.567l-19.399 8.444a1.9 1.9 0 0 1-2.515-1.03c-.415-.996.037-2.142 1.012-2.567Z"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#Expense-Popup_svg__f)">
        <path
          fill="#fff"
          fillOpacity={0.6}
          d="M70.671 45.91 41.867 58.45a1.9 1.9 0 0 1-2.515-1.032c-.416-.995.037-2.141 1.012-2.566l28.804-12.54a1.9 1.9 0 0 1 2.515 1.032c.416.995-.036 2.141-1.012 2.566Z"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#Expense-Popup_svg__g)">
        <path
          fill="#fff"
          fillOpacity={0.6}
          d="M58.924 63.785 46.507 69.28a1.9 1.9 0 0 1-2.515-1.03c-.416-.996.036-2.142 1.012-2.567l12.417-5.496a1.9 1.9 0 0 1 2.515 1.032c.416.995-.036 2.141-1.012 2.566Z"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#Expense-Popup_svg__h)">
        <path
          fill="#fff"
          fillOpacity={0.6}
          d="m79.96 67.593-28.805 12.54a1.9 1.9 0 0 1-2.514-1.031c-.416-.996.036-2.142 1.012-2.567l28.804-12.54a1.9 1.9 0 0 1 2.515 1.032c.415.995-.037 2.141-1.013 2.566Z"
          shapeRendering="crispEdges"
        />
      </g>
    </g>
    <defs>
      <filter
        id="Expense-Popup_svg__b"
        width={105.263}
        height={116.143}
        x={3.551}
        y={-13.737}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={2.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_63_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_63_24529"
          result="shape"
        />
      </filter>
      <filter
        id="Expense-Popup_svg__d"
        width={28.134}
        height={34.56}
        x={19.478}
        y={6.533}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={2.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_63_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_63_24529"
          result="shape"
        />
      </filter>
      <filter
        id="Expense-Popup_svg__e"
        width={33.234}
        height={22.358}
        x={29.65}
        y={32.499}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={2.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_63_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_63_24529"
          result="shape"
        />
      </filter>
      <filter
        id="Expense-Popup_svg__f"
        width={42.64}
        height={26.453}
        x={34.198}
        y={39.155}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={2.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_63_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_63_24529"
          result="shape"
        />
      </filter>
      <filter
        id="Expense-Popup_svg__g"
        width={26.253}
        height={19.409}
        x={38.837}
        y={57.029}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={2.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_63_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_63_24529"
          result="shape"
        />
      </filter>
      <filter
        id="Expense-Popup_svg__h"
        width={42.64}
        height={26.453}
        x={43.486}
        y={60.838}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={2.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_63_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_63_24529"
          result="shape"
        />
      </filter>
      <linearGradient
        id="Expense-Popup_svg__a"
        x1={46.538}
        x2={103.235}
        y1={95.701}
        y2={-4.834}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5FCEB6" />
        <stop offset={1} stopColor="#588AF2" />
      </linearGradient>
      <linearGradient
        id="Expense-Popup_svg__c"
        x1={44.03}
        x2={124.565}
        y1={97.067}
        y2={2.705}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5FCEB6" />
        <stop offset={1} stopColor="#588AF2" />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgExpensePopup
